import React, { useState } from 'react'
import { Box, Typography, IconButton, TextField, Tooltip, Paper, Grid } from '@mui/material'
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

export default function VerificationRecordItem({ type, host, value }) {
  const [copiedValue, setCopiedValue] = useState('')

  const handleCopy = async (textToCopy, fieldName) => {
    try {
      await navigator.clipboard.writeText(textToCopy)
      setCopiedValue(fieldName)
      setTimeout(() => setCopiedValue(''), 2000)
    } catch (err) {
      console.error('Failed to copy text: ', err)
    }
  }

  const renderField = (label, fieldValue, fieldName, iniitialWidth) => (
    <Grid item xs={iniitialWidth} sm={6} md={iniitialWidth}>
      <Box sx={recordItemStyles.valueContainer}>
        <TextField
          fullWidth
          label={label}
          variant='outlined'
          size='small'
          value={fieldValue}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <Tooltip title={copiedValue === fieldName ? 'Copied!' : 'Copy to clipboard'} placement='top'>
                <IconButton
                  onClick={() => handleCopy(fieldValue, fieldName)}
                  size='small'
                  color={copiedValue === fieldName ? 'success' : 'default'}
                >
                  {copiedValue === fieldName ? (
                    <CheckCircleOutlineIcon fontSize='small' />
                  ) : (
                    <FileCopyOutlinedIcon fontSize='small' />
                  )}
                </IconButton>
              </Tooltip>
            )
          }}
          sx={recordItemStyles.textField}
        />
      </Box>
    </Grid>
  )

  return (
    <Paper sx={recordItemStyles.paper} variant='outlined'>
      <Grid xs={12} container spacing={1} alignItems='center'>
        {renderField('', type, 'type', 2)}
        {renderField('Hostname', host, 'host', 5)}
        {renderField('Value', value, 'value', 5)}
      </Grid>
    </Paper>
  )
}
const recordItemStyles = {
  paper: {
    p: 1.5,
    mb: 1.5,
    backgroundColor: theme => theme.palette.background.default
  },
  valueContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '14px',
      height: '60px',
      backgroundColor: '#fff'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #E7E7EE'
    },
    '& .MuiInputBase-input': {
      fontFamily: 'Plus Jakarta Sans',
      fontWeight: 400,
      fontSize: '16px'
    }
  }
}
